import React from 'react';
import CountryScreeningResults from './CountryScreeningResults';
import EARScreeningResults from './EARScreeningResults';

interface CountryControlListResultsProps {
  workflowData?: any;
  /** Commodity code + destination for the control-list part's screening table. */
  primary?: string;
  country?: string;
  isExpands?: boolean;
  /** A pre-merge chat may hold a separate control-list (old "Sensitive Tech") result
   *  message — render just that part under the merged phase's title. */
  showCountryPart?: boolean;
  showControlListPart?: boolean;
}

/**
 * The Country and Control List Check result (UX redesign, 2026-10-03): ONE phase, two parts —
 * the destination-country screen (data.country_screening) and the commodity control-list
 * screen (data.export_screening, incl. the Appendix-X niche-PGA rows) — shown together under
 * the phase title. Each part keeps its existing card.
 */
const CountryControlListResults: React.FC<CountryControlListResultsProps> = ({
  workflowData,
  primary,
  country,
  isExpands = true,
  showCountryPart = true,
  showControlListPart = true,
}) => (
  <div className='country-control-list-results'>
    <div className='country-control-list-results-title'>
      Country and Control List Check
    </div>
    {showCountryPart && (
      <CountryScreeningResults
        title='Destination country'
        saveBtn={undefined}
        handleRowClick={() => undefined}
        workflowData={workflowData}
        isSelected={false}
        isExpands={isExpands}
      />
    )}
    {showControlListPart && (
      <EARScreeningResults
        title='Control lists for this product'
        primary={primary}
        country={country}
        workflowData={workflowData}
        isSelected={false}
        isExpands={isExpands}
      />
    )}
  </div>
);

export default CountryControlListResults;
